import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

export default function LoginViewport({ children }) {
  const { t } = useTranslation();

  return (
    <section className="flex min-h-screen bg-slate-950">
      <div className="relative hidden w-0 flex-1 lg:block bg-slate-950 overflow-hidden">
        <div className="absolute top-0 -left-10 animate-blob-1">
          <div className="w-96 h-96 bg-blue-600 rounded-full mix-blend-screen filter blur-[128px] opacity-40"></div>
        </div>

        <div className="absolute bottom-0 right-0 animate-blob-2">
          <div className="w-[30rem] h-[30rem] bg-indigo-600 rounded-full mix-blend-screen filter blur-[128px] opacity-40"></div>
        </div>

        <div className="absolute top-1/2 left-1/2 animate-blob-3">
          <div className="w-[40rem] h-[40rem] bg-cyan-700 rounded-full mix-blend-screen filter blur-[150px] opacity-30 transform -translate-x-1/2 -translate-y-1/2"></div>
        </div>

        <div className="absolute inset-0 flex flex-col justify-center px-16 lg:px-24 z-10">
          <div className="mb-10">
            <img
              className="h-14 w-auto"
              src="/public/assets/logo-harpiAI.svg"
              alt="HarpiAI Logo"
            />
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight">
            {t('Login:Artificial intelligence')} <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
              {t('Login:supporting diagnostic')}
            </span>
          </h1>

          <p className="mt-6 text-white text-lg md:text-xl text-slate-300 max-w-xl font-light leading-relaxed">
            {t('Login:Empowering healthcare')}
          </p>
        </div>
      </div>

      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-28 bg-slate-900 z-20 shadow-[-20px_0_40px_-10px_rgba(0,0,0,0.5)] border-l border-white/10">
        <div className="mx-auto w-full max-w-sm lg:w-[400px]">
          {children}
        </div>
      </div>
    </section>
  );
};
